import {Link} from 'react-router-dom'
import {ProgressCircle, searchAndFindInSessions} from './AM_ReaperConnectionSupport'
import AudioFileOutlinedIcon from '@mui/icons-material/AudioFileOutlined';
import SplitscreenOutlinedIcon from '@mui/icons-material/SplitscreenOutlined';
import {useState, useEffect, forwardRef, useImperativeHandle, useRef} from 'react'
import {singularOrPlural} from '../../API_GET'

export const ModalHeaders = (props) => {
    const data = props.data

    if(data.type === 'usedFiles'){
        return `Files already in use (${data.data.length})`
    }

    if(data.type === 'preliminaryReaperUpload'){
        const readyCount = data.listEditedFiles.filter(item => item.problem_found === false).length;
        return `Audio file lists: Ready to upload (${readyCount}/${data.listEditedFiles.length})`
    }   
    if(data.type === 'settingsProblems'){
        return `Warning: Settings problems detected`
    }

    if(data.type === 'findInFolders'){
        return 'Find Source Files into Reaper Sessions'
    }
    return null
}

export const modalWidth = (props) => {
    if(['usedFiles', 'preliminaryReaperUpload'].includes(props)){
        return 'calc(100vw - 200px)'
    }
    if(props === 'findInFolders'){
        return '800px'
    }
    if(props === 'settingsProblems'){
        return '500px'
    }
    return '200px'
}

export const ModalContent = forwardRef((props, ref) => {
    const data = props.data
    const API = window?.electronAPI

    const sessionListFoundRef = useRef(null)

    useImperativeHandle(ref, () => ({
        searchInRpp: () => {
            sessionListFoundRef.current?.searchInRpp()
        },
        searchAndFind: () => {
            sessionListFoundRef.current?.searchAndFind()
        }
    }));

    /*const send = async() => {
        TEST DIRECT MESSAGES
        const info = await props.electronMessages({request: 'info'})
        console.log("SONO LA RISP", info)
    }*/

    const sendCustorPositionToReaper = async (position) => {
        await props.ww_reaperQuest('setPosition', `SET/EXTSTATE/AMDirectConnection/info/${position};`)
    }

    if(data.type === 'usedFiles'){ 
        return <div className="">
                <h6><b>Some files are already in use</b></h6>
                <div>
                <table className="table table-sm showusedfiles">
                    <tbody>
                        {data.data.map((list, idx) => {
                            return <tr key={`${list.path}-${idx}`}>
                                <td>{list.path}</td>
                                <td width="20">
                                    <button className="btn btn-sm btn-primary-outline p-0" 
                                        onClick={() => API.shell.showItemInFolder(list.path)}
                                        title="Select file in folder">
                                        <i className="bi bi-folder"/>
                                    </button>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
                </div>
            </div>
    }

    if(data.type === 'preliminaryReaperUpload'){
        return <div style={{height: 'calc(100vh - 250px)', overflowY: 'auto'}}>
            {data.listEditedFiles.length > 0 ?
                <table className="table table-sm showusedfiles">
                    <tbody>
                        
                        {data.listEditedFiles.map((list, idx) => {
                            return <tr key={`${list.path}-${idx}`} style={{height: '38px', background: list.problem_found ? '#ff000021' : null}} className="align-middle">
                                    <td width="40">{list?.isReaper ? <SplitscreenOutlinedIcon /> : <AudioFileOutlinedIcon /> }</td>
                                    <td style={{color: list.problem_found ? 'red' : null}} className="ps-2">{list.target_filename}</td>
                                    <td width="40" className="text-center">{list?.flag_code ? 
                                        <div className={`flag-icon flag-icon-${list.flag_code}`}
                                            title={list.language_code}
                                            style={{ width: '26px', marginRight: '2px'}}
                                        /> :
                                        <div className="spinner-grow spinner-grow-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    }</td>
                                    <td>
                                        <TargetFileType data={list} />
                                        <AudioFormat data={list} />
                                    </td>
                                    <td width="80">
                                        {list?.progress == null ? (
                                            <span style={{color: list.problem_found ? 'red' : 'green'}}>{list.problem_found ? 'To Check' : 'Ready'}</span>
                                        ) : list?.progress === 0 ? (
                                            <span>Waiting...</span>
                                        ) : (
                                            <ProgressCircle progress={list.progress} />
                                        )}
                                    </td>
                                    <td>
                                        {list.problem_found ? 
                                        <ul className="mb-0">
                                            {list.edit_details.map((issue, idx) => {
                                                return <li key={idx}>{issue}</li>
                                            })}
                                        </ul>
                                        : ''}
                                    </td>

                                    <td width="60" className="text-end">
                                        {list?.isReaper ?
                                        <button className="btn btn-sm btn-primary-outline p-0 me-2"
                                            onClick={() => sendCustorPositionToReaper(list.source_position)}
                                            title={`Go to Reaper position (${list.source_position})`}>
                                            <i className="bi bi-geo-alt"></i>
                                        </button>
                                        : null}
                                        
                                        
                                        <button className="btn btn-sm btn-primary-outline p-0"
                                            onClick={() => props.deleteLine(list)}
                                            title="Remove file from list">
                                            <i className="bi bi-trash" />
                                        </button>

                                    </td>
                                </tr>
                            })}
                    </tbody>
                </table>
                : <div className="nofilesWarning">
                    No Files
                </div>

            }
            </div>
    }

    if(data.type === 'settingsProblems'){
        return <div style={{fontSize: '14px'}}>
                <div>Some settings are not set correctly</div>
                <ul>
                {data?.settingsProblems?.map(err => {
                    return <li key={err}>{err} <i className="bi bi-exclamation-triangle text-danger"></i></li>
                })}
                </ul>
                <div>Go in <Link onClick={props.closeModal} to={'/userdata/KRAST'}>Account Settings</Link> to correct</div>

            </div>
    }

    if(data.type === 'get-infoscript-from-sourceFiles'){
        return "CHECK!!!"
    }

    if(data.type === 'findInFolders'){
        const info = data.findData

        const openFolder = async () => {
            const folder = await API.openFolderDialog()
            if(folder){
                props.updateFindInFolders(folder)
            }

        }

        return <><table className="table table-sm krast-info-search">
                    <tbody>
                        <tr>
                            <td className="krast-table-section">Project name:</td>
                            <td>{info.project_name}</td>
                        </tr>
                        <tr>
                            <td className="krast-table-section">Filename:</td>
                            <td>{info.source_filename}</td>
                        </tr>
                    </tbody>
                </table>
                <div className="krast-container-searchinRpp">
                    <h6 className="text-muted mb-0">Find in Folder</h6>
                    <div className="drop-area-searchInRpp">
                        <button className="btn btn-primary btn-sm" onClick={openFolder}>Open Path</button>
                        <span className="krast-path-searchInRpp">{data?.previousPath ? data.previousPath : 'select a path'}</span>
                    </div>
                </div>

                <SessionListFound ref={sessionListFoundRef} data={data} openSession={props.openSession} toggleFindIntoSession={props.toggleFindIntoSession} updateSearchingState={props.updateSearchingState} />

        </>  
    }

    return null
})

export const ModalButtons = (props) => {

    const data = props.data

    const updateFilesToS3 = () => {
        props.updateFilesToS3(props.uploadTag)  // <-- USA DIRETTAMENTE props.uploadTag
    }

    if(data.type === 'usedFiles'){
        return <button className="btn btn-sm btn-primary" style={{width: '90px'}} onClick={props.closeModal}>Got it!</button>
    }
    
    if(data.type === 'preliminaryReaperUpload'){

        const readyFiles = data.listEditedFiles.filter(item => item.problem_found === false);
        const allUploaded = readyFiles.every(file => file.progress === 100);
        const hasReadyFiles = readyFiles.length > 0;

        return <table className="krast-table-upload-button">
                <tbody>
                    <tr>
                        <td width="20%" className="nodisplay text-start ps-3 ">
                            <input type="checkbox" checked={data.notOpenAnymore} onChange={props.toggleNotOpenAnymore}/>
                            Don't open anymore
                        </td>
                        <td width="20%"></td>
                        <td width="130px">
                            <button className="btn btn-sm btn-primary" 
                            style={{width: '90px'}}

                            disabled={data.listEditedFiles.length === 0 || !hasReadyFiles || allUploaded}
                            onClick={updateFilesToS3}>
                                Upload
                                {data.isUploading && <i className="bi bi-hourglass-split"></i>}
                            </button>
                        </td>
                        <td width="20%"><UploadTag 
                                            uploadTag={props.uploadTag}
                                            updateUploadTag={props.updateUploadTag}
                                            markPost={props.markPost}
                                            updateMarkPost={props.updateMarkPost}

                                        />
                        </td>
                        <td className="krast-table-remove-options" width="15%">
                            <a href="/" onClick={props.promptDeleteAllLines}>
                                Remove All
                            </a>
                            <a href="/" onClick={props.deletedUploadedFiles}>
                                Remove Uploaded
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
    }

    if(data.type === 'findInFolders'){
        return <>
        <button disabled={!data.previousPath || data.isSeaching} onClick={props.searchInRpp} className="btn btn-primary btn-sm">
            {data.isSeaching ? 'Searching...' : 'Find into Sessions'}
        </button>
        </>
    }
    return null
}


export const PromptDeteteLines = (props) => {

    return  <div className="krast-modal-prompt-deletion">
                <div>Are you sure you want to remove all files from the list?</div>
                <button className="btn btn-secondary btn-sm" onClick={() => props.deleteAllLines(false)}>Close</button>
                <button className="btn btn-danger btn-sm" onClick={() => props.deleteAllLines(true)}>Continue</button>
            </div>
}

const SessionListFound = forwardRef((props, ref) => {

    const [infoSession, setInfoSession] = useState(props.data);
    const API = window?.electronAPI

    // Sync internal state when props.data changes
    useEffect(() => {
        // Sync only previousPath, preserve sessionFound
        setInfoSession(prev => ({
            ...prev,
            previousPath: props.data.previousPath,
            findData: props.data.findData
        }));
        return () => {
            setInfoSession(prev => ({
            ...prev,
            findData: {}
        }));
        }
    }, [props.data.previousPath, props.data.findData]);

    useImperativeHandle(ref, () => ({
        searchAndFind: () => {
            searchAndFind()
        }
    }));

    const openSession = (info) => {
        props.openSession(info)
    }

    const searchAndFind = async () => {
        // Reset stato
        props.toggleFindIntoSession(false);
        props.updateSearchingState?.(true);
        setInfoSession(prev => ({
            ...prev,
            sessionFound: [],
            totalSessions: 0,
            isSeaching: true
        }));

        try {
            // Call the search function in support with callbacks for rolling updates
            const result = await searchAndFindInSessions(
                infoSession.previousPath,
                props.data.findData,
                (progress) => {
                    // Progressive update: add the found session
                    setInfoSession(prev => ({
                        ...prev,
                        sessionFound: [...prev.sessionFound, progress.session],
                        totalSessions: progress.totalSessions
                    }));
                }
            );

            // End search
            setInfoSession(prev => ({
                ...prev,
                isSeaching: false,
                totalSessions: result.totalSessions
            }));
            
            if(result.totalSessions > 0){
                props.toggleFindIntoSession(true);
            }
        } catch (error) {
            console.error("Error during search:", error);
            // End search even in case of error
            setInfoSession(prev => ({
                ...prev,
                isSeaching: false
            }));
        } finally {
            props.updateSearchingState?.(false);
        }
    }

    return  infoSession?.isSeaching ? <div className="krast-search-rpp-spinner">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        </div> 
            : 
            <div className="krast-found-rpp-sessions">
            {!infoSession?.totalSessions ? 
                <div className="text-center text-muted">Click "Find into Sessions" to start searching</div> :
            infoSession?.sessionFound && infoSession.sessionFound.length === 0 ?
                <div className="text-center text-danger">No results found (searched in {infoSession?.totalSessions} {singularOrPlural(infoSession?.totalSessions, 'session', 'sessions')})</div> : 
                <>
                <h6 className="text-muted mb-0">Found {infoSession?.sessionFound?.length} of {infoSession?.totalSessions}</h6>
                <div style={{position: 'relative', height: '95%', overflowY: 'auto'}}>
                    <table className="krast-find-inrpp table table-sm" style={{width: '100%'}}>
                        <tbody>
                        {infoSession?.sessionFound?.map((session, index) => (
                            <tr key={index}>
                                <td title={session.path}>{session.name}</td>
                                <td style={{width: '80px'}}>
                                    <button className="btn btn-sm btn-primary-outline p-0" 
                                        onClick={() => API.shell.showItemInFolder(session.path)}
                                        title="Select file in folder">
                                        <i className="bi bi-folder"/>
                                    </button>

                                    <span className="badge bg-success ms-2">{session.tagCount}</span>
                                    {session.hasTag && (
                                        <button className="btn krast-reaper-button ms-2" 
                                            title="Reveal in session"
                                            onClick={() => openSession(session)}>
                                            R
                                        </button>

                                    )}
                                </td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </>}
            </div>
            

})

const UploadTag = (props) => {

    const defaultValues = {
        status: false,
        name: '',
        id: null
    }

    const removeInfo = () => {
        props.updateUploadTag(defaultValues);  // <-- USA IL CALLBACK
    }

    const updateName = (value) => {
        props.updateUploadTag({
            ...props.uploadTag,
            name: value
        });
    }

    /*const updateMarkPost = () =>{
        props.updateMarkPost();
    }*/

    return <div id="uploadTagContainer" className="d-flex align-items-center gap-2">
            
                <div className="input-group input-group-sm">
                    <span className="description">Upload Tag</span>
                    <input onChange={(e) => updateName(e.target.value)} 
                        className={`tagvalue${props.uploadTag.status ? ' hastag' : ''}`} 
                        value={props.uploadTag.name} 
                        disabled={props.uploadTag.status}  
                        type="text" />
                    {props.uploadTag.status ? 
                    <span className="input-group-text rightElement" 
                        onClick={removeInfo}
                        title="Remove Upload Tag">
                        <i className="hastag bi bi-x" />
                    </span> : null}
                    
                </div>
                {/*<span onClick={updateMarkPost}
                    style={{cursor: 'pointer'}}
                    title="Mark as Post-produced"
                    disabled={true}
                    className={`mt-1 ms-2 badge text-dark ${props.markPost ? 'bg-warning' : 'bg-light'}`}
                    >
                        Post-pro
                </span>*/}
            </div>
}

const TargetFileType = (props) =>{
    const data = props.data
    
    if (!data) return null;

    const title = [];

    if (data?.specs_samplerate) {
        title.push(data?.specs_samplerate + ' Hz');
    }
    if (data?.specs_bitdepth) {
        title.push(data?.specs_bitdepth + ' bit');
    }
    if (data?.specs_channels) {
        title.push(data?.specs_channels + ' channels');
    }

    const filetypeValue = data?.file_description ? 
    <b>{data.file_description} <i title={title.join(' | ')} className="bi bi-info-circle"></i></b>
     : <span className="text-danger">[No Filetype]</span>
    return <div>FileType: {filetypeValue}</div>
}

const AudioFormat = (props) => {
    const { data } = props;
    if (!data) return null;

    const currentFile = data?.specs || {};

    // Map of properties to compare: [current file key, requested date key, suffix]
    const fields = [
        { currentVal: currentFile.sampleRate, requiredVal: data.specs_samplerate, unit: 'Hz' },
        { currentVal: currentFile.bitsPerSample, requiredVal: data.specs_bitdepth, unit: 'bit' },
        { currentVal: currentFile.numberOfChannels, requiredVal: data.specs_channels, unit: 'ch' },
    ];

    const renderedSpecs = fields
        .filter(({ currentVal }) => currentVal !== undefined && currentVal !== null)
        .map(({ currentVal, requiredVal, unit }, index) => {
        // Transform into a string or homogeneous number for comparison
        const isMatch = requiredVal != null && String(currentVal) === String(requiredVal);
        const colorStyle = isMatch ? { color: 'green' } : { color: 'red' };

        return (
            <span key={index} style={colorStyle}>
            {currentVal}{unit}
            </span>
        )
    })

    if (renderedSpecs.length === 0) return null;

    return (
        <div>
        {renderedSpecs.reduce((acc, curr, index) => 
            index === 0 ? [curr] : [...acc, ' | ', curr], []
        )}
        </div>
    )
}
